var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time-entries-details"},[(!_vm.$can('visit', 'KPI'))?_c('NotLoggedPanel',{attrs:{"user":_vm.user}}):_vm._e(),(_vm.$can('visit', 'KPI'))?_c('TimeEntriesDetailsList'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }